export const MEETING_APP_URL = process.env.REACT_APP_MEETING_APP_URL;
export const MEETING_METHODS = ["Phone call", "Zoom", "FaceTime", "Google Meet", "Video call (Meeting app)"];
export const TIERS = [
  { id: "30-min", title: "30-Minute Session", price: "99.99", short: "Phone or video · one focused problem" },
  { id: "1-hour", title: "1-Hour Session", price: "149.99", short: "Phone or video · time to dig in" },
  { id: "90-min", title: "1½-Hour Video Call", price: "249.99", short: "Full video walkthrough for bigger jobs" },
];
